module.exports = __webpack_public_path__ + "img/git-merge.829cc31d.svg";